"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightningStrike = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LightningStrike = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "lightning-strike", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "lightning-strike", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "m8.154 17.45 9.038-13.995c.529-.833 1.81-.445 1.81.545l-.006 8.996 4.007.003c.775 0 1.262.86.843 1.52l-9.038 14.022c-.528.833-1.81.45-1.81-.54L13.004 19H8.997c-.775 0-1.262-.89-.843-1.55Z", fill: "#909AB5" }) })) })));
};
exports.LightningStrike = LightningStrike;
